<template lang='html'>
<v-tab-item :id="name">
    <!--  -->
    <v-flex xl12 lg12 md12 xs12>
        <component :is="show_style"></component>
    </v-flex>
</v-tab-item>
</template>

<script>
	/* eslint-disable */
import ItemList  from "./product_item_list"
import ItemTable from "./product_item_table"
export default {
    //template:``,
    name: '',
    props:{
    	name:{type:String,default:'tab-sale'}
    },
    computed:{},
    methods:{},
    components:{ItemList,ItemTable},
    watch:{},
    directives: {},
    mounted :function(){},
    data () {
      return {
      	 sheet:false,
      	 show_style:"ItemTable",
      	 tiles: [
	        { img: 'keep.png', title: 'Keep' },
	        { img: 'inbox.png', title: 'Inbox' },
	        { img: 'hangouts.png', title: 'Hangouts' },
	        { img: 'messenger.png', title: 'Messenger' },
	        { img: 'google.png', title: 'Google+' }
	      ]
      }
    },
    filters: {
      //pluralize: (n, w) => n === 1 ? w : (w + 's'),
      capitalize: s => s.charAt(0).toUpperCase() + s.slice(1)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.list__tile {
	padding: 0 0 !important;
}
.badge_count span.badge__badge{
	right :4px !important;
}
.badge--overlap {
	top:0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/front_sale/components/saleorder.vue